import { render, staticRenderFns } from "./ProdutoManage.vue?vue&type=template&id=6458ea5d"
import script from "./ProdutoManage.vue?vue&type=script&lang=js"
export * from "./ProdutoManage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports